<template>
    <div v-if="additionals">
        <div v-if="model && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-form
                ref="RkmFormRequisicao"
                show-legend
            >
                <rkm-area
                    title="Dados da requisição"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="!!id || (additionals && !additionals.salaVacinacaoLogada.responsavel)"
                                :options="unidadesDe"
                                :validations="validations.unidadeIdDe"
                                @change="handleUnidadeIdDeChange"
                                label="Unidade requisitante"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.unidadeIdDe"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="!!id || !model.unidadeIdDe || (additionals && !additionals.salaVacinacaoLogada.responsavel)"
                                :options="salasVacinacaoDe"
                                :validations="validations.salaVacinacaoIdDe"
                                label="Local requisitante"
                                show-default-option
                                text-field="nome"
                                v-model="model.salaVacinacaoIdDe"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="!!id"
                                :options="unidadesPara"
                                :validations="validations.unidadeIdPara"
                                @change="handleUnidadeIdParaChange"
                                label="Unidade requisitada"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.unidadeIdPara"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="!!id || !model.unidadeIdPara"
                                :options="salasVacinacaoPara"
                                :validations="validations.salaVacinacaoIdPara"
                                label="Local requisitado"
                                show-default-option
                                text-field="nome"
                                v-model="model.salaVacinacaoIdPara"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-date-picker
                                disabled
                                label="Data"
                                v-model="model.dataRequisicao"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                disabled
                                label="Código"
                                v-model="model.codigo"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                disabled
                                label="Usuário solicitante"
                                v-model="model.usuarioNome"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-form>

            <rkm-form ref="RkmFormVacina">
                <rkm-area
                    title="Vacina"
                    type="fieldset"
                >
                    <template v-if="!id">
                        <rkm-row>
                            <rkm-col cols="8">
                                <rkm-form-input-autocomplete
                                    :repository="repositories.vacina"
                                    :search-fields="fields.autocomplete"
                                    :text-field="item => item.id ? `${autocompleteTextField(item)}` : item.nome"
                                    :validations="validations.vacinaId"
                                    label="Vacina"
                                    v-model="local.vacina"
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    :validations="validations.quantidade"
                                    label="Quantidade"
                                    type="number"
                                    v-model="local.quantidade"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    :label="false"
                                    @click="handleInserirClick"
                                    color="primary"
                                >
                                    Incluir
                                </rkm-button>

                                <rkm-button
                                    :disabled="!local.vacina"
                                    :label="false"
                                    @click="handleLimpar"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-textarea
                                    :validations="validations.observacao"
                                    label="Observação"
                                    v-model="local.observacao"
                                    rows="4"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <rkm-row
                        v-if="model.statusId === enums.requisicaoStatus.FINALIZADA"
                        class="mb-2"
                    >
                        <rkm-col class="legend">
                            <span class="warning legend-square ml-0" /> Quantidade enviada é diferente de quantidade recebida
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-table
                                :fields="fields.table"
                                :items="model.vacinas"
                                :tbody-tr-class="rowClass"
                                ref="RkmTableVacina"
                            >
                                <template v-slot:cell(quantidadeEnviada)="row">
                                    <span v-if="model.statusId === enums.requisicaoStatus.FINALIZADA && model.salaVacinacaoIdDe === additionals.salaVacinacaoLogada.id">
                                        {{ row.item.lotes.reduce((sum, lote) => {return sum + parseInt(lote.quantidadeEnviada)}, 0) }}
                                    </span>

                                    <rkm-form-input
                                        v-else
                                        :value="row.item.lotes.reduce((sum, lote) => {return sum + parseInt(lote.quantidadeEnviada)}, 0)"
                                        class="m-0"
                                        disabled
                                        type="number"
                                    >
                                        <rkm-input-group-append slot="append">
                                            <rkm-button
                                                :title="searchButtonTitle"
                                                @click="$refs.ModalLote.open(row.item)"
                                                color="primary"
                                            >
                                                <rkm-icon icon="search" />
                                            </rkm-button>
                                        </rkm-input-group-append>
                                    </rkm-form-input>
                                </template>

                                <template v-slot:cell(quantidadeRecebida)="row">
                                    <rkm-form-input
                                        :value="row.item.lotes.reduce((sum, lote) => {return sum + parseInt(lote.quantidadeRecebida)}, 0)"
                                        class="m-0"
                                        disabled
                                        type="number"
                                    >
                                        <rkm-input-group-append slot="append">
                                            <rkm-button
                                                :title="searchButtonTitle"
                                                @click="$refs.ModalLote.open(row.item)"
                                                color="primary"
                                            >
                                                <rkm-icon icon="search" />
                                            </rkm-button>
                                        </rkm-input-group-append>
                                    </rkm-form-input>
                                </template>

                                <template v-slot:cell(motivo)="row">
                                    <rkm-form-select
                                        :disabled="
                                            row.item.estoqueSalaVacinacaoPara === 0 ||
                                            model.statusId === enums.requisicaoStatus.RESPONDIDA ||
                                            model.statusId === enums.requisicaoStatus.FINALIZADA
                                        "
                                        :options="form.motivos"
                                        class="m-0"
                                        show-default-option
                                        text-field="nome"
                                        v-model="row.item.motivoId"
                                        value-field="id"
                                    />
                                </template>

                                <template v-slot:cell(actions)="{ index }">
                                    <rkm-button
                                        @click="handleDestroy(index)"
                                        color="danger"
                                        small
                                        title="Excluir"
                                    >
                                        <rkm-icon icon="trash" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-form>

            <ModalLote
                :additionals="additionals"
                :model="model"
                ref="ModalLote"
            />
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar uma requisição.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalLote from './components/lote/Modal'

// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import requisicaoStatus from '@/enums/imunizacao/requisicaoStatus'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalLote },
    computed: {
        fields() {
            const autocomplete = []
            const table = []

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.push({ key: 'sigla', searchable: true })
                    autocomplete.push({ key: 'abreviacao', searchable: true })
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;

                default:
                    autocomplete.push({ key: 'nome', searchable: true })
                    break;
            }

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    table.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    table.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    table.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    table.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    table.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    table.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    table.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            if (this.model.statusId === null) {
                table.push(
                    { key: 'quantidade', label: 'Quantidade requisitada' },
                    { key: 'observacao', label: 'Observação' },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                )
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    table.push(
                        { key: 'quantidade', label: 'Quantidade requisitada' },
                        { key: 'observacao', label: 'Observação' },
                    )
                } else {
                    table.push(
                        { key: 'estoqueSalaVacinacaoPara', label: 'Estoque da sala de vacinação requisitada' },
                        { key: 'estoqueSalaVacinacaoDe', label: 'Estoque da sala de vacinação requisitante' },
                        { key: 'quantidade', label: 'Quantidade requisitada' },
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'observacao', label: 'Observação' },
                        { key: 'motivo', label: 'Motivo' },
                    )
                }
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    table.push(
                        { key: 'quantidade', label: 'Quantidade requisitada' },
                        { key: 'quantidadeRecebida', label: 'Quantidade recebida' },
                        { key: 'observacao', label: 'Observação' },
                        { key: 'motivo', label: 'Motivo' },
                    )
                } else {
                    table.push(
                        { key: 'quantidade', label: 'Quantidade requisitada' },
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'observacao', label: 'Observação' },
                        { key: 'motivo', label: 'Motivo' },
                    )
                }
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.FINALIZADA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    table.push(
                        { key: 'quantidade', label: 'Quantidade requisitada' },
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'quantidadeRecebida', label: 'Quantidade recebida' },
                        { key: 'observacao', label: 'Observação' },
                        { key: 'motivo', label: 'Motivo' },
                    )
                } else {
                    table.push(
                        { key: 'quantidade', label: 'Quantidade requisitada' },
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'observacao', label: 'Observação' },
                        { key: 'motivo', label: 'Motivo' },
                    )
                }
            }

            return {
                autocomplete,
                table,
            }
        },
        validations() {
            return {
                unidadeIdDe: { required: true },
                salaVacinacaoIdDe: { required: true },
                unidadeIdPara: { required: true },
                salaVacinacaoIdPara: { required: true },
                vacinaId: { required: true },
                quantidade: {
                    required: true,
                    min_value: 1,
                    max: 8,
                },
                observacao: {
                    min: 1,
                    max: 5000,
                },
            }
        },
        unidadesDe() {
            return this.form.unidadesDe.filter(unidadeDe => unidadeDe.id !== this.model.unidadeIdPara)
        },
        salasVacinacaoDe() {
            return this.form.salasVacinacaoDe.filter(salaVacinacaoDe => salaVacinacaoDe.id !== this.model.salaVacinacaoIdPara)
        },
        unidadesPara() {
            return this.form.unidadesPara.filter(unidadePara => unidadePara.id !== this.model.unidadeIdDe)
        },
        salasVacinacaoPara() {
            return this.form.salasVacinacaoPara.filter(salaVacinacaoPara => salaVacinacaoPara.id !== this.model.salaVacinacaoIdDe)
        },
        searchButtonTitle() {
            let title = ''

            if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                title = 'Lotes disponíveis'
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    title = 'Lotes recebidos'
                } else {
                    title = 'Lotes enviados'
                }
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.FINALIZADA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    title = 'Lotes recebidos'
                } else {
                    title = 'Lotes enviados'
                }
            }

            return title
        },
    },
    created() {
        this.repositories = {
            requisicao: this.getConectaSusRepository('imunizacao.requisicao'),
            vacina: this.getConectaSusRepository('cadastro.vacina'),
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina, requisicaoStatus },
        form: null,
        local: {
            vacina: null,
            quantidade: null,
            observacao: null,
        },
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.requisicao.edit(this.id)
                    .then(response => {
                        this.additionals = Object.assign(response.data.additionals)
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)

                        this.$emit('loaded', { additionals: this.additionals, model: this.model })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.requisicao.create()
                    .then(response => {
                        this.additionals = Object.assign(response.data.additionals)
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)

                        this.$emit('loaded', { additionals: this.additionals, model: this.model })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleUnidadeIdDeChange(id) {
            this.model.salaVacinacaoIdDe = null

            const request = {
                listar: 'salas_vacinacao_de',
                unidadeIdDe: id,
            }

            this.setLoading()

            this.repositories.requisicao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.salasVacinacaoDe = Object.assign(response.data)

                    if (this.form.salasVacinacaoDe.length === 1) {
                        const selected = this.form.salasVacinacaoDe[0]
                        this.model.salaVacinacaoIdDe = selected.id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeIdParaChange(id) {
            this.model.salaVacinacaoIdPara = null

            const request = {
                listar: 'salas_vacinacao_para',
                unidadeIdPara: id,
            }

            this.setLoading()

            this.repositories.requisicao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.salasVacinacaoPara = Object.assign(response.data)

                    if (this.form.salasVacinacaoPara.length === 1) {
                        const selected = this.form.salasVacinacaoPara[0]
                        this.model.salaVacinacaoIdPara = selected.id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInserirClick() {
            this.$refs.RkmFormVacina.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.vacinas.find(vacina => vacina.vacinaId === this.local.vacina.id)) {
                        this.showValidationNotification('A vacina seleciona já foi Incluída.')
                        return
                    }

                    const vacina = {
                        vacinaId: this.local.vacina.id,
                        vacinaNome: this.local.vacina.nome,
                        vacinaAbreviacao: this.local.vacina.abreviacao,
                        vacinaSigla: this.local.vacina.sigla,
                        vacinaSiglaNome: `${this.local.vacina.sigla} - ${this.local.vacina.nome}`,
                        vacinaSiglaAbreviacao: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao}`,
                        vacinaAbreviacaoNome: `${this.local.vacina.abreviacao} - ${this.local.vacina.nome}`,
                        vacinaSiglaAbreviacaoNome: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao} -
                            ${this.local.vacina.nome}`,
                        quantidade: Number(this.local.quantidade),
                        observacao: this.local.observacao,
                    }

                    this.model.vacinas.push(vacina)
                    this.resetRkmFormVacina()
                })
        },
        handleLimpar() {
            this.resetRkmFormVacina()
        },
        resetRkmFormVacina() {
            this.local = {
                vacina: null,
                quantidade: null,
                observacao: null,
            }

            this.$refs.RkmFormVacina.resetValidator()
        },
        handleDestroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a vacina?', async () => this.model.vacinas.splice(index, 1))
        },
        handleSave() {
            const request = {
                statusId: this.model.statusId,
                vacinas: this.model.vacinas.map(vacina => {
                    return {
                        lotes: vacina.lotes.map(lote => {
                            return {
                                id: lote.id,
                                quantidadeRecebida: lote.quantidadeRecebida,
                            }
                        }),
                    }
                })
            }

            this.setLoading()

            this.repositories.requisicao.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.showSaveNotification()
                    this.$emit('save', response)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmFormRequisicao.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.statusId === null) {
                        if (this.model.vacinas.length === 0) {
                            this.showValidationNotification('Obrigatório incluir pelo menos uma vacina.')
                            return
                        }

                        this.setLoading()

                        const request = {
                            statusId: this.model.statusId,
                            salaVacinacaoIdDe: this.model.salaVacinacaoIdDe,
                            salaVacinacaoIdPara: this.model.salaVacinacaoIdPara,
                            usuarioId: this.model.usuarioId,
                            dataRequisicao: moment(this.model.dataRequisicao).format('DD/MM/YYYY'),
                            codigo: this.model.codigo,
                            vacinas: this.model.vacinas.map(vacina => {
                                return {
                                    vacinaId: vacina.vacinaId,
                                    quantidade: vacina.quantidade,
                                    observacao: vacina.observacao,
                                }
                            }),
                        }

                        this.repositories.requisicao.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                    else if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                        const request = {
                            statusId: this.model.statusId,
                            vacinas: this.model.vacinas.map(vacina => {
                                return {
                                    id: vacina.id,
                                    motivoId: vacina.motivoId,
                                    lotes: vacina.lotes.map(lote => {
                                        return {
                                            id: lote.id,
                                            quantidadeEnviada: lote.quantidadeEnviada,
                                        }
                                    }),
                                }
                            })
                        }

                        this.setLoading()

                        this.repositories.requisicao.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                    else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                        const diferencas = this.model.vacinas.filter(vacina => {
                            return vacina.lotes.reduce((sum, lote) => {return sum + parseInt(lote.quantidadeEnviada)}, 0) >
                                vacina.lotes.reduce((sum, lote) => {return sum + parseInt(lote.quantidadeRecebida)}, 0)
                        })

                        if (diferencas.length > 0) {
                            const vacinas = diferencas.map(diferenca => diferenca.vacinaNome).join('<br/>')

                            this.showConfirmation(
                                `Há uma diferença entre a Quantidade enviado e a Quantidade recebido. Essa diferença será retornada ao estoque do
                                    local de atendimento que realizou o envio da(s) seguinte(s) vacina(s): <br/><br/>${vacinas}<br/><br/>Deseja continuar?`,
                                async () => this.handleSave(),
                            )
                        } else {
                            this.handleSave()
                        }
                    }
                })
        },
        rowClass(item, type) {
            if (item && type === 'row') {
                if (this.model.statusId !== this.enums.requisicaoStatus.PENDENTE && item.lotes && item.lotes.filter(lote => lote.quantidadeEnviada !== lote.quantidadeRecebida).length > 0) {
                    return 'table-warning'
                }
            }
        },
        autocompleteTextField(item) {

            let textField = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    textField = `${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    textField = `${item.sigla}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    textField = `${item.sigla} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    textField = `${item.sigla} - ${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.abreviacao} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.sigla} - ${item.abreviacao} - ${item.nome}`
                    break;

                default:
                    textField = `${item.nome}`
                    break;
            }

            return textField
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>

<style scoped>
.legend {
    align-items: center;
    display: flex;
}
.legend-square {
    border: 1px solid black;
    display: inline-block;
    height: 20px;
    margin-left: 10px;
    margin-right: 5px;
    width: 20px;
}
.danger {
    background-color: #ed969e;
}
.info {
    background-color: #86cfda;
}
.warning {
    background-color: #ffe8a1;
}
</style>